module.exports = __webpack_public_path__ + "91202c9324114ce41ab01bad8d81ae0c.svg";